import { newsService } from "@/api/news.service";
import { searchService } from "@/api/search.service";
import { emitterInstance } from "@/classes/emitter";
import { SearchHistory } from "@/classes/searchHistory";
import SearchHistoryService from "@/services/searchHistoryService";
import type { Praeparat } from "@/types/otc/praeparat";
import { reactive, ref } from "vue";
export interface SearchCategory {
    name: string;
    alias: string;
    isActive:boolean;
    results:any[];
    totalResults:number;
    key: string;
}
export class SearchResults{
    results:any[];
    resultTotalCount: number;

    constructor(item:any){
        this.results = item.results ?? item.Results ??[] as any;
        this.resultTotalCount = item.resultTotalCount ?? item.ResultTotalCount ?? this.results.length;
    }
}


export function useContentSearch(){
    let searchCategories= ref<SearchCategory[]>([]);
    let searchTerm = ref<string>('');
    let searchCount = ref<number>(0);

    const search = async (term:string):Promise<void> =>{
        searchTerm.value = term;
        searchCount.value=0;
        await initializeSearchCategories();

        const praeparateResults = await searchProducts(term);
        categorieseSearchResults(praeparateResults, 'Arzneimittel (System)',searchCategories.value);
        const contentResults=   await searchContent(term, 'Gesundheitsthemen');      
        searchCategories.value = categorieseSearchResults(contentResults, 'Gesundheitsthemen', searchCategories.value);
        const pageResults= await searchContent(term, 'Seiten');            
        searchCategories.value = categorieseSearchResults(pageResults, 'Seiten', searchCategories.value);
        const mediaResults = await searchMedia(term);
        searchCategories.value = categorieseSearchResults(mediaResults, 'Downloads (System)', searchCategories.value);
        const newsResults = await searchNews(term);        
        searchCategories.value = categorieseSearchResults(newsResults, 'Blog (System)', searchCategories.value);
        getResultsCount();

    };

    const searchProducts = async (term:string, start:number= -1, take:number = 0):Promise<SearchResults> =>{
        return await searchService.praeparateFullText(term, start, take);
    };
    const searchContent = async (term:string, category:string, start:number= -1, take:number = 0):Promise<SearchResults> =>{
        return await searchService.contentFullText(term, getCategoryKeyByName(category),start, take);
    };
    const searchMedia = async (term:string, start:number= -1, take:number = 0):Promise<SearchResults> =>{
        return await searchService.mediaFullText(term, start, take );
    };
    const searchNews = async (term:string, start:number= -1, take:number = 0):Promise<SearchResults> =>{
        const newsResult = await newsService.getNews(term, start, take );
        return new SearchResults(newsResult);
    }

    const initializeSearchCategories = async ():Promise<void> => {
        searchCategories.value =  await searchService.searchCategories() as SearchCategory[];
        const useHistory = SearchHistoryService.Instance.checkHistoryMark();
        if(useHistory){         
            await reloadSearchHistory();
        }
    }
    const categorieseSearchResults = (searchResults:any, categoryAlias:string, categories: SearchCategory[]):SearchCategory[]=> {
        const categoryIndex = categories.findIndex(c=> c.alias == categoryAlias);
        if(searchResults && searchResults.results && searchResults.results.length>0){            
            searchResults.results.forEach((result:any) => {
                const values = result.values? result.values: result;
                (categories)[categoryIndex].results.push(values);
                (categories)[categoryIndex].totalResults = searchResults.resultTotalCount;
            });
        }
        return categories;
    }
    const getCategoryKeyByName = (name:string): string=>{
        const category = searchCategories.value.find(x => x.name === name);
        return category? category.alias : "";
        // return category? category.key.toString(): "";
    }
    const onReadMore = (props:{product: Praeparat}) => {
            setSearchHistory(props.product.id.toString());
            const url = props.product.url ? props.product.url : `/praeparat/${props.product.id}`;
            window.location.href = url;
    };
    const onOrder = (pzns: string[]) => {

        if (!pzns.length) return;

            return pzns.join(',');
        };
    const onPflichttext = (productId: number, praeparatId: number) => {
        const url = `/produkte/pflichttext?product=${productId}&praeparat=${praeparatId}`;
        window.open(url, '_self');
        setSearchHistory(productId.toString());
    };
    const moreResults = async(term: string, category:SearchCategory, categories:SearchCategory[])=>{
        let moreResults;
        switch(category.alias){
            case "Arzneimittel (System)":
                moreResults = await searchProducts(term,category.results.length);
                break;
            case "Downloads (System)":
                moreResults = await searchMedia(term, category.results.length);
                break;
            case "Blog (System)":
                moreResults = await searchNews(term, category.results.length);
                break;
            default:
                moreResults = await searchContent(term, category.alias, category.results.length);
        }        
        searchCategories.value = categorieseSearchResults(moreResults, category.alias, categories);
        getResultsCount();
    };
    const getResultsCount = ()=>{
        let resultCount = 0;
        searchCategories.value.forEach( c => {
            if(c.results){                
                resultCount+=c.results.length;
            }
        });
        searchCount.value = resultCount;
    }
    const setSearchHistory = (clicked: string) => {
        let contentCat = [] as  Array<{alias:string, itemcount:number, isActive:boolean}>;
        searchCategories.value.forEach( cat => {
            contentCat.push({
                alias: cat.alias,
                itemcount: cat.results ? cat.results.length: 0,
                isActive: cat.isActive
            });
        });
        const searchHistory = new SearchHistory({
            searchTerm: searchTerm.value,
            historyType: "content",
            contentCategories: contentCat,
            id: clicked,
            contentShowOverlay: true,
        })
        SearchHistoryService.Instance.setSearchHistory(searchHistory);
    }
    const reloadSearchHistory = async (): Promise<boolean> =>{
        //get
        const searchHistory = SearchHistoryService.Instance.getSearchHistory();
        //auswerten
        if(searchHistory && searchHistory.historyType && searchHistory.historyType=="content"){
            const term = searchHistory.searchTerm;
            const historyCategories = searchHistory.contentCategories;
            let historyCategory;
            const searchCats = searchCategories.value;
            for(const category of searchCategories.value){                
                historyCategory = historyCategories.find(x=> x.alias == category.alias);
                if(historyCategory){
                    category.isActive = historyCategory.isActive;
                    let results: SearchResults = {} as SearchResults;
                    switch(category.alias){
                        case "Arzneimittel (System)":
                            results = await searchProducts(term,0, historyCategory.itemcount);                            
                            break;
                        case "Downloads (System)":
                            results = await searchMedia(term,0, historyCategory.itemcount);
                            break;
                        case "Gesundheitsthemen":
                        case "Seiten":
                            results = await searchContent(term, category.alias, 0, historyCategory.itemcount);
                            break;
                        case "Blog (System)":
                            const newsResults = await searchNews(term,0, historyCategory.itemcount);
                            results = new SearchResults(newsResults);
                            break;
                        default:
                            break;
                    }  
                    category.results = results.results;
                    category.totalResults = results.resultTotalCount;  
                }                    
            };             
            getResultsCount();
            searchTerm.value = searchHistory.searchTerm; 
            emitterInstance.emit("updateSearchTerm", searchHistory.searchTerm);
            emitterInstance.emit("toggleSearch", searchHistory.contentShowOverlay);
            //löschen
            SearchHistoryService.Instance.removeSearchHistory();

            setTimeout(function(){                    
                const clickedElement = document.getElementById(searchHistory.id);
                if(clickedElement){
                    clickedElement.scrollIntoView({behavior: 'smooth'});
                }
            }, 1000);
            return true;
        }
        return false;
    }
    return {
        searchCategories,
        searchTerm,
        searchCount,
        moreResults,
        onReadMore,
        onOrder,
        onPflichttext,
        search,
        initializeSearchCategories,
        setSearchHistory
    };
}